/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  getReporteCasoCerradosByProject ({ commit }, item) {

    console.log('ReporteCasoCerradosByProject, item ', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/reportes/casoCerradosByProject',
          { idUser: item.idUser,
            idProject: item.idProject,
            sbFechaIni: item.sbFechaIni,
            sbFechaFin: item.sbFechaFin
          },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('ReporteCasoCerradosByProject ', response)

          if (response.data.nuOK === 0) {
            const lista = response.data.data ? response.data.data : []
            commit('SET_REPORTE_CASO_BY_PROJECT', lista)
            resolve(response.data)
          } else if (response.data.nuOK === 1 && response.data.data.length == 0) {
            console.log('actionReporte', 'lista vacia en casos cerrados.')
            commit('SET_REPORTE_CASO_BY_PROJECT', [])

            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log('casoCerradosByProject error, ', error)
          reject(error)
        })
    })
  },


  getReporteCasoByStatusByProject ({ commit }, item) {

    console.log('ReporteCasoByStatusByProject, item ', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/reportes/casoByStatusByProject',
          { idUser: item.idUser,
            idProject: item.idProject,
            sbFechaIni: item.sbFechaIni,
            sbFechaFin: item.sbFechaFin,
            sbEstado: item.sbEstado
          },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('ReporteCasoByStatusByProject ', response)

          if (response.data.nuOK === 0) {
            const lista = response.data.data ? response.data.data : []
            commit('SET_REPORTE_CASO_BY_PROJECT', lista)
            resolve(response.data)
          } else if (response.data.nuOK === 1 && response.data.data.length == 0) {
            console.log('actionReporte', 'lista vacia en casos abiertos.')
            commit('SET_REPORTE_CASO_BY_PROJECT', [])

            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log('casoAbiertosByProject error, ', error)
          reject(error)
        })
    })
  },

  clearAllReporte({ commit }) {
    commit('SET_REPORTE_CASO_BY_PROJECT', [])
  },


}
